import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/$module_id/$entity_type_id/segments/$segment_id')({
    component: RouteComponent,
})

function RouteComponent() {
    return <>
        <Outlet />
    </>
}
